import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitLayoutsHeader.module.scss';

const Header = ({
  centerColumn = null,
  className = '',
  leftColumn = null,
  rightColumn = null,
  testId = '',
}) => (
  <header
    className={classnames(styles.element, className)}
    data-testid={testId}
  >
    <div className={classnames(styles.column, styles.isPositionLeft)}>
      {leftColumn}
    </div>
    <div className={classnames(styles.column, styles.isPositionCenter)}>
      {centerColumn}
    </div>
    <div className={classnames(styles.column, styles.isPositionRight)}>
      {rightColumn}
    </div>
  </header>
);

Header.propTypes = {
  leftColumn: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.func,
    PropTypes.string,
    PropTypes.element,
  ]),
  centerColumn: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.func,
    PropTypes.string,
    PropTypes.element,
  ]),
  rightColumn: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.func,
    PropTypes.string,
    PropTypes.element,
  ]),
  className: PropTypes.string,
  testId: PropTypes.string,
};

export default Header;
